// Modal Components
export { default as Modal } from './modal';
export { default as FormModal } from './form-modal';

// Other common components
export { default as Header } from './header';
export { default as Footer } from './footer';
export { default as Hero } from './hero';
export { default as AboutArea } from './about-area';
export { default as About } from './about';
export { default as AwardAreaCard } from './award-area-card';
export { default as AwardArea } from './award-area';
export { default as BlogAreaCard } from './blog-area-card';
export { default as BlogArea } from './blog-area';
export { default as ClientArea3 } from './client-area-3';
export { default as ClientArea } from './client-area';
export { default as ExplorAreaCard } from './explor-area-card';
export { default as Explor } from './explor';
export { default as FaqAreaBar } from './faq-area-bar';
export { default as FaqArea } from './faq-area';
export { default as IcpAreaCard } from './icp-area-card';
export { default as MarqueeArea2 } from './marquee-area-2';
export { default as MarqueeArea3 } from './marquee-area-3';
export { default as MarqueeArea4 } from './marquee-area-4';
export { default as MarqueeArea5 } from './marquee-area-5';
export { default as MarqueeArea } from './marquee-area';
export { default as Meter } from './meter';
export { default as OurAchievement } from './our-achievement';
export { default as Pagination } from './pagination';
export { default as PricingPlanCard } from './pricing-plan-card';
export { default as PricingPlan } from './pricing-plan';
export { default as ProjectAreaCard } from './project-area-card';
export { default as ProjectCardArea2 } from './project-card-area-2';
export { default as ProjectCardArea3 } from './project-card-area-3';
export { default as ServiceArea2 } from './service-area-2';
export { default as ServiceAreaOtherCard } from '../home/service-area-other-card';
export { default as ServiceArea } from './service-area';
export { default as TeamAreaCard } from './team-area-card';
export { default as Testimonial } from './testimonial';
export { default as VideoArea2 } from './video-area-2';
export { default as VideoArea3 } from './video-area-3';
export { default as VideoArea4 } from './video-area-4';
export { default as VideoArea } from './video-area';
